import { FC } from "react";

import { cn } from "@src/lib/utils/cn";
import { LocationGroupType } from "@src/types.generated";

import type { RecommendationListItem } from "./GuestFeedbackView";

export type RecommendationBrand = {
  name: string;
  logoUrl?: string;
};

/**
 * The brand a recommendation is scoped to, or null when it isn't scoped to a
 * brand.
 */
export function getRecommendationBrand(
  recommendation: RecommendationListItem,
): RecommendationBrand | null {
  const locationGroup = recommendation.locationGroup;
  if (locationGroup?.type !== LocationGroupType.Brand) return null;
  const logoUrls = locationGroup.brandDetails?.logoUrls;
  return {
    name: locationGroup.name,
    logoUrl: logoUrls?.thumb ?? logoUrls?.original ?? undefined,
  };
}

/**
 * Renders the brand logo for a recommendation. Returns null when the
 * recommendation has no associated brand logo.
 */
const RecommendationBrandLogo: FC<{
  recommendation: RecommendationListItem;
  className?: string;
}> = ({ recommendation, className }) => {
  const brand = getRecommendationBrand(recommendation);
  if (!brand?.logoUrl) return null;

  return (
    <img
      src={brand.logoUrl}
      alt={brand.name}
      title={brand.name}
      className={cn(
        "size-5 shrink-0 overflow-hidden rounded-full object-cover ring-1 ring-gray-1",
        className,
      )}
    />
  );
};

export default RecommendationBrandLogo;
